import { byCodes, chunkPostsKP, getPostNum } from "../../../../constant/General";

function ResultTable({ result, config, column }) {

    const is3Rows = column === 3;
    const getRowsPosts = is3Rows ? config.threeRows : config.fourRows;
    let posts = byCodes(result.rightResults, getRowsPosts);
    const getPosts = chunkPostsKP(posts, is3Rows);

    return (<div style={{
        backgroundImage: `url(${require(`../../../../assets/images/live-v2/${config.type}/day/bg.png`)})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%"
    }} className="w-50 d-flex justify-content-center align-items-center">
        <div className="position-relative">
            <img height="750" className="w-100"
                src={require(`../../../../assets/images/live-v2/${config.type}/day/${is3Rows ? "3rows" : "4rows"}.png`)}
                alt="__" />

            <div style={{
                top: "0px", left: "0px",
                fontSize: "80px"
            }} className="position-absolute post-kp w-100 h-100">
                {
                    getPosts.map((e, r) => {
                        const style = is3Rows ? config[`row_post3_${r}`] : config[`row_post_${r}`];
                        const styleHeight = is3Rows ? config.row_post3_height : config.row_post_height;
                        const styleNum = is3Rows ? config[`row_post_3num_${r}`] : config[`row_post_num_${r}`];
                        return <div key={r} className="d-flex" style={{ ...style, ...styleHeight }}>
                            {
                                e.map((post, i) => {
                                    const isMargin = !["A", "B", "N", "P"].includes((post.postCode));
                                    return <div key={i} className="">
                                        <div
                                            className="text-center d-flex align-items-center justify-content-center scale-text"
                                            style={isMargin ? { ...styleNum, marginLeft: "10px" } : styleNum}>
                                            {getPostNum(post.twoD)}
                                        </div>
                                        <div
                                            className="text-center d-flex align-items-center justify-content-center scale-text"
                                            style={isMargin ? { ...styleNum, marginLeft: "10px" } : styleNum}>
                                            {getPostNum(post.threeD)}
                                        </div>
                                    </div>
                                })
                            }
                        </div>
                    })
                }
            </div>
        </div>
    </div>);
}

export default ResultTable;